<form name="TaxCategorySlabForm" (ngSubmit)="Validate(TaxCategorySlabForm)" #TaxCategorySlabForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Tax Category Slab</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col px-1 pt-2">
                    <label>Financial Year</label>
                    <ng-select name="FinancialYear" [items]="FinancialYears" bindLabel="FinancialYear"
                        bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Detail.ESS_TaxFinancialYearID"
                        placeholder="Financial Year" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select financial year.
                    </div>
                </div>
                <!-- <div class="col-md-6 px-1 pt-2">
                    <label>Financial Year Start</label>
                    <div class="input-group mb-3">
                        <input type="number" class="form-control" placeholder="Ex. 2024" id="FinancialYearStart"
                            name="FinancialYearStart" [(ngModel)]="Detail.YearStart" #FinancialYearStart="ngModel"
                            pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)" maxlength="4"
                            (change)="SetFinancialYearEnd()" required>
                        <span class="input-group-text" id="Year">Year</span>
                        <div class="invalid-feedback">
                            Please enter financial year start.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 px-1 pt-2">
                    <label>Financial Year End</label>
                    <div class="input-group mb-3">
                        <input type="number" class="form-control" placeholder="Ex. 2025" id="FinancialYearEnd"
                            name="FinancialYearEnd" [(ngModel)]="Detail.YearEnd" #FinancialYearEnd="ngModel"
                            pattern="^[0-9]\d*$" maxlength="4" (keypress)="common.NumberOnly($event)" required disabled>
                        <span class="input-group-text" id="Year">Year</span>
                        <div class="invalid-feedback">
                            Please enter financial year end.
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row">
                <div class="col-md-12 px-1 pt-2">
                    <label>Tax</label>
                    <ng-select name="TaxCategoryID" [items]="TaxCategorys" bindLabel="Name"
                        bindValue="ESS_TaxCategoryMasterID" [(ngModel)]="Detail.ESS_TaxCategoryMasterID"
                        placeholder="Tax Category" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select tax.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 px-1 pt-2">
                    <label>From Amount</label>
                    <input type="text" class="form-control" placeholder="Ex. 1000" id="SlabFrom" name="SlabFrom"
                        [(ngModel)]="Detail.SlabFrom" #SlabFrom="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" maxlength="6" required>
                    <div class="invalid-feedback">
                        Please enter from amount.
                    </div>
                </div>
                <div class="col-md-6 px-1 pt-2">
                    <label>To Amount</label>
                    <input type="text" class="form-control" placeholder="Ex. 3000" id="SlabTo" name="SlabTo"
                        [(ngModel)]="Detail.SlabTo" #SlabTo="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" maxlength="6" required>
                    <div class="invalid-feedback">
                        Please enter to amount.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 px-1 pt-2">
                    <label>Percentage</label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="Ex. 20" id="PercValue" name="PercValue"
                            [(ngModel)]="Detail.PercValue" #PercValue="ngModel" pattern="^[0-9]\d*$"
                            (keypress)="common.NumberOnly($event)" maxlength="3" required>
                        <span class="input-group-text" id="PercentageIcon">%</span>
                        <div class="invalid-feedback">
                            Please enter percentage.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 px-1 pt-2 align-self-center">
                    <div class="btn-group btn-group-toggle" style="width: 100%;">
                        <label class="form-check-label link-dark px-1" style="margin-left: 5%;" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=true name='IsNewRegime'
                                [(ngModel)]="Detail.IsNewRegime">
                            New Regime
                        </label>
                        <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=false name='IsNewRegime'
                                [(ngModel)]="Detail.IsNewRegime">
                            Old Regime
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button
                        *ngIf="(this.Detail.ESS_TaxSlabMasterID == 0 && this.common.PageRight.IsAdd) || (this.Detail.ESS_TaxSlabMasterID > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>

    </div>
</form>